 /* eslint-disable */
 import React, { useState, useEffect} from 'react'
 import Suppliers from './Suppliers'
 import EditSupplier from './EditSupplier'
 import { getAllSuppliers, getSuppliersByUser } from '../../actions/supplierActions'
 import { useDispatch, useSelector } from 'react-redux'
 import { useLocation, useHistory } from 'react-router-dom'
 import NoData from '../svgIcons/NoData'
 import Spinner from '../Spinner/Spinner'
 
 
 const SupplierList = () => {
 
     const history = useHistory()
     const location = useLocation()
     const [open, setOpen] = useState(false)
     const [currentId, setCurrentId] = useState(null)
     const dispatch = useDispatch()
     const user = JSON.parse(localStorage.getItem('profile'))
     const {suppliers} = useSelector((state) => state.suppliers)
     //("Suppliers",suppliers)
    
     const isLoading = useSelector(state => state.suppliers.isLoading)
     // const suppliers = []
 
     
     // useEffect(() => {
     // }, [currentId, dispatch]);
     
 //     useEffect(() => {
 //         dispatch(getSuppliers(1));
 //         // dispatch(getSuppliersByUser({userId : user?.result?.id}));
 //         // dispatch(getSuppliersByUser({ search :user?.result?.id, tags: tags.join(',') }));
 //     },[location]
 // )
 
 useEffect(() => {
   dispatch(getAllSuppliers());
     // dispatch(getSuppliersByUser({ search: user?.result?.id || user.result.googleId }));
   },[location])
 
   if(!user) {
     history.push('/login')
   }
 
   
   if(isLoading) {
     return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
         <Spinner />
     </div>
   }
 
   if(suppliers.length === 0) {
     return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
       <NoData />
     <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No Suppliers yet. Click the plus icon to add Supplier</p>
   
     </div>
   }
 
     return (
         <div>
             <EditSupplier 
                 open={open} 
                 setOpen={setOpen}
                 currentId={currentId}
                 setCurrentId={setCurrentId}
             />
             <Suppliers 
                 open={open} 
                 setOpen={setOpen}
                 currentId={currentId}
                 setCurrentId={setCurrentId}
                 suppliers={suppliers}
             />
         </div>
     )
 }
 
 export default SupplierList
 
 